import { ApiClient } from './client';

export const SUPPORT_CATEGORIES = ['account', 'billing', 'generation', 'bug', 'suggestion', 'other'] as const;
export const SUPPORT_SURFACES = ['account', 'pricing', 'canvas', 'kagemane', 'hypit', 'library', 'other'] as const;
export const SUPPORT_SCREENSHOT_LIMIT = 3;
export const SUPPORT_SCREENSHOT_BYTES = 2 * 1024 * 1024;
export interface SupportPayload {
  category: typeof SUPPORT_CATEGORIES[number];
  surface: typeof SUPPORT_SURFACES[number];
  description: string;
  screenshots: { content: string }[];
}
class SupportApi extends ApiClient {
  submit(payload: SupportPayload) {
    return this.request<{ status: 'sent' }>('/support', { method: 'POST', body: JSON.stringify(payload) });
  }
}
export const supportApi = new SupportApi();
